<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <div slot="header"></div>
      <ul class="nav">
        <li class="nav-item" v-for="(item, index) in listSideBar">
          <div v-if="item.line" class="bottomLine"></div>
          <div v-if="item.overview" class="overview">{{ item.overview }}</div>
          <template>
            <SidebarNavIcons :name="item.name" :url="item.url" :icon="item.icon"
                             :notifyNumber="item.notifyNumber" :eventStatus="item.eventStatus"></SidebarNavIcons>
          </template>
        </li>
      </ul>
      <div slot="footer"></div>
    </nav>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import SidebarNavIcons from './SidebarNavIcons';
  import consts from '../../_consts';

  export default {
    name: 'sidebar',
    data () {
      return {}
    },
    components: {
      SidebarNavIcons
    },
    computed: {
      listSideBar () {
        let drafts = this.countUnreadEventByStatus('drafts');
        let submitted = this.countUnreadEventByStatus('submitted');
        let review = this.countUnreadEventByStatus('review');
        let approved = this.countUnreadEventByStatus('approved');
        let archived = this.countUnreadEventByStatus('archived');
        let deleted = this.countUnreadEventByStatus('deleted');
        let data = [
          {
            name: consts.sideBarItemNames.dashboard,
            url: '/user/dashboard',
            icon: consts.iconNames.areaChart,
            overview: consts.sideBarItemNames.overview,
            notifyNumber: 0
          },
          {
            name: consts.sideBarItemNames.newEvent,
            url: `/user/events`,
            icon: consts.iconNames.plusCircle,
            overview: consts.sideBarItemNames.events,
            line: 'ok',
            notifyNumber: 0
          },
          {
            name: consts.sideBarItemNames.draft,
            url: `/user/drafts`,
            icon: consts.iconNames.fileText,
            notifyNumber: drafts
          },
          {
            name: consts.sideBarItemNames.submitted,
            url: `/user/submitted`,
            icon: consts.iconNames.inbox,
            notifyNumber: submitted,
            eventStatus: consts.eventStatus.submitted
          },
          {
            name: consts.sideBarItemNames.review,
            url: `/user/review`,
            icon: consts.iconNames.eye,
            notifyNumber: review,
            eventStatus: consts.eventStatus.review
          },
          {
            name: consts.sideBarItemNames.approved,
            url: `/user/approved`,
            icon: consts.iconNames.calendar,
            notifyNumber: approved
          },
          {
            name: consts.sideBarItemNames.archived,
            url: `/user/archived`,
            icon: consts.iconNames.archive,
            notifyNumber: archived
          }
        ];
        if (localStorage.getItem('sof_role') === consts.USER_ROLE.admin) {
          let deleteData = {
            name: consts.sideBarItemNames.deleted,
            url: `/user/deleted`,
            icon: consts.iconNames.deleted,
            notifyNumber: deleted
          };
          data.push(deleteData);
        }
        return data;
      },
      ...mapGetters({
        countUnreadEventByStatus: 'GETTERS_COUNT_UNREAD_EVENT_BY_STATUS'
      })
    },
    methods: {
      handleClick (e) {
        e.preventDefault();
        e.target.parentElement.classList.toggle('open');
      }
    }
  };
</script>

<style lang="css">
  .nav-link {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?2084f99e